package tools

actual fun normalizeString(input: String): String = js("input.normalize('NFKD').replace(/[^\\w]/g, '');") as String
